export function WSLoadImage() {
  var parentWS = this["parentWS"];
  var imgIdx = this["index"];
  parentWS.ImageLoaded(imgIdx);
}
